(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    function designSwap() {
  const products = document.querySelectorAll('.product__media-item'); // grab all product images (li parent container)
  const checkedRadio = document.querySelector('.brand-radio input[type=radio]:checked'); // find the radio inputs that are checked

  products.forEach(item => {
    item.classList.remove('is-active'); // remove class from each product image
  });

  if (checkedRadio) {
    const targetId = checkedRadio.dataset.target; // grab data attribute of radio that is checked
    const targetProduct = document.getElementById(targetId); 

    if (targetProduct) {
      targetProduct.classList.add('is-active'); // add .is-active to the product image (list item) that is attached to the radio button
    }
  }
}

const radioContainer = document.querySelector('.brand-radio');

radioContainer.addEventListener('change', designSwap); // run the function when a radio button changes state

document.addEventListener('DOMContentLoaded', () => {
  const consent = document.querySelector('[data-consent]');
  const addToCart = document.querySelector('button[name="add"]');

  if (!consent || !addToCart) return;

  addToCart.disabled = true;

  consent.addEventListener('change', () => {
    addToCart.disabled = !consent.checked; // disable the add to cart button when the checkbox is unchecked
  });
});
  } catch(e) { console.error(e); }
})();

})();
